
import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 添加token到请求头
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['X-HXCharge-Authentication'] = `${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    let res = response.data
	//console.log(res)
    // 业务状态码处理
    if (res.code !== "0") {
      Message.error(res.message || 'Error')
      // 特殊状态码处理
      if (res.code === "401") {
        router.push('/login')
      }
      return Promise.reject(new Error(res.message || 'Error'))
    }
    return res
  },
  error => {
	  console.log(error)
    // HTTP状态码处理
    if (error.response) {
      switch (error.response.status) {
        case 401:
          try {
			this.$router.push('/login')
          } catch (err) {
            if (err.name !== 'NavigationDuplicated') return Promise.reject(error)
          }
          break
        case 403:
          Message.error('无权限访问')
          break
        case 500:
          Message.error('服务器错误')
          break
        default:
          //Message.error(error.message)
      }
    }
    return Promise.reject(error)
  }
)

export default service
